import React, { useState } from 'react';
import { FiFacebook } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LoginForm = ({ extraClass, loginStyle }) => {
    const history = useHistory();



    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await axios.post(`${API_BASE_URL}/customer/login`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });

            const token = response.data.access_token;

            if (token) {
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(response.data.customer));
                localStorage.setItem('customer_id', response.data.customer.id); // ✅ ADD THIS
                localStorage.setItem('customer_email', response.data.customer.email);
                localStorage.setItem('token_created_at', new Date().toISOString()); 
                setSuccess('Login successful!');

                // Fire custom event to update header
                window.dispatchEvent(new Event('tokenUpdated'));

                // Redirect after short delay
                setTimeout(() => {
                    history.push('/dashboard');
                }, 1500);
            } else {
                setError('Login failed: Token not received');
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data) {
                setError(err.response.data.message || 'Something went wrong.');
            } else {
                setError('Network error.');
            }
        }

        setLoading(false);
    };

    return (
        <div className={`newsletter-area ${loginStyle}`}>
            <div className="container">
                <div className={`row row--0 newsletter-wrapper align-items-center ${extraClass}`}>
                    <div className="col-lg-4">
                        <div className="newsletter-section-title">
                            <h3 className="title">Welcome Back</h3>
                            <p className="description">Login to continue accessing your dashboard.</p>
                            <p>Don't Have Account? <Link to='/signup' className='text-primary'>Register Here</Link></p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <form className="rn-newsletter mt_md--20 mt_sm--20" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    required
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>

                            {error && <p className="text-danger">{error}</p>}
                            {success && <p className="text-success">{success}</p>}

                            <div className="form-group d-flex justify-content-between align-items-center">
                                <button className="btn-default" disabled={loading}>
                                    {loading ? 'Logging in...' : 'Login'}
                                </button>
                                <Link to="/password-reset" className="text-link">Forgot Password?</Link>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Loader Popup */}
                {loading && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0,0,0,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999
                        }}
                    >
                        <div
                            style={{
                                background: '#fff',
                                padding: '30px 40px',
                                borderRadius: '10px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.2)',
                                fontSize: '18px',
                                fontWeight: '500'
                            }}
                        >
                            Please wait, logging in...
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginForm;
